import { PaymentType } from '@/shared/types/response.types'
import { VisitorType } from '@/shared/types/store.types'
import { PurchaseFlowRoutes, LandingRoutes } from '@/shared/types/router.types'

export const MAX_VISITORS = 10
export const DEFAULT_NUMBER_OF_VISITORS = 1
export const OWNER_RELATION = { CODE: '009', NAME: 'Self' }
export const GENDERS = { FEMALE: 2, MALE: 1 }
export const paymentMethods = ['credit-card', 'naps', 'apple-pay', 'google-pay']
export const defaultVisitor: VisitorType = {
  srNo: 0,
  firstName: '',
  lastName: '',
  birthDate: null,
  nationality: null,
  nationalityName: null,
  country: null,
  passport: '',
  visa: '',
  email: '',
  phoneInfo: {
    phone: '+974',
    countryCode: 'QA',
    isValid: false,
  },
  id: '',
  getVisa: true,
  contactsSame: true,
  relationship: '',
  relationshipName: '',
  gender: 1,
  passportExpiryDate: null,
}
export const paymentMap: { [key: string]: PaymentType } = {
  credit: 'CC',
  naps: 'DC',
  google: 'GP',
  apple: 'AP',
}

export const QATAR_INBOUND_KEY = 'qic-qatar-visitors_country_of_residence'
export const STATE_LIST_INS_KEY = 'state-page'
export const viewsMap = {
  QUOTE: 'quote',
  ADD_VISITOR: 'add-visitor',
  EDIT_VISITOR: 'edit-visitor',
}
export const analyticsPageMapping = {
  [PurchaseFlowRoutes.TRAVEL_DATE]: 'select_date',
  [PurchaseFlowRoutes.HOLDER_INFO]: 'holder_info',
  [PurchaseFlowRoutes.TRAVEL_DURATION]: 'select_duration',
  [PurchaseFlowRoutes.QUOTE]: 'your_quote',
  [PurchaseFlowRoutes.INSURANCE_RESULT]: 'donwloading_policy',
  [viewsMap.ADD_VISITOR]: 'add_person',
  [viewsMap.EDIT_VISITOR]: 'edit_person',
  [LandingRoutes.POLICY_DOWNLOAD]: 'downloading_policy',
}

export const A_B_KEY = 'qic-visitors_flow_ab_state'

export const DURATION_CODE = 'VISITORS2MONTHSDURATION'
export const DURATION_KEYS = ['VISITORS2MONTHSDURATION-B1', 'VISITORS2MONTHSDURATION-B2']
export const INBOUND_ADDON_CODE = 'VISITORSINBADDONNEW'
export const INBOUND_ADDON_KEYS = ['VISITORSINBADDONNEW-B1', 'VISITORSINBADDONNEW-B2']
export const AUTO_COMP_CODE = 'VISITORSEAUTOCOMP'
export const AUTO_COMP_KEYS = ['VISITORSEAUTOCOMP-B1', 'VISITORSEAUTOCOMP-B2']

export const OCR_CODE = 'VISITORSOCRINDPAK'
export const OCR_KEYS = ['VISITORSOCRINDPAK-B1']

export const FLOW_REFERRER_KEY = 'visitors.flow_referrer'

export const durationForInboundAddon = ['V30', 'V60', 'V90']

export const NAME_MAX_LENGTH = 60

export const STATE_POLICY_DOWNLOAD_KEY = 'policy-download-state'

export const STATE_POLICY_DOWNLOAD_VALUE = {
  POLICY_DOWNLOAD: 'policy-download',
  POLICY_DOWNLOAD_LIST: 'policy-download-list',
}
